// Catálogo de voces del generador de voz de Gemini (tabla `voces_google`)
// para el modo "Video con influencer" V2 (ADR-550).
//
// A diferencia de `voces` (ElevenLabs), acá la CLAVE es `nombre`: el nombre
// exacto de la voz Gemini (campo `voice` de speech_config) — es lo que viaja
// como `voz_id` en el payload del webhook. `sexo` es etiqueta editorial para
// el filtro del picker. Sin clonado de voz en este proveedor.

import { supabase } from '../../lib/supabase';

export interface GoogleVoice {
  /** uuid de la fila (solo para keys de React). */
  id: string;
  /** Nombre EXACTO de la voz Gemini — viaja como `voz_id`. */
  nombre: string;
  /** Descriptor de estilo (Brillante, Animada, Firme…). */
  estilo: string | null;
  sexo: string | null;
  descripcion: string | null;
  /** URL de preview reproducible (null hasta que se generen). */
  previewUrl: string | null;
}

/** Trae las voces Google activas, ordenadas por nombre. */
export async function fetchGoogleVoices(): Promise<GoogleVoice[]> {
  const { data, error } = await supabase
    .from('voces_google')
    .select('id, nombre, estilo, sexo, descripcion, preview_url')
    .eq('activo', true)
    .order('nombre');
  if (error || !data) {
    if (error) console.error('[googleVoicesApi] fetchGoogleVoices', error);
    return [];
  }
  type Row = {
    id: string | number;
    nombre: string | null;
    estilo: string | null;
    sexo: string | null;
    descripcion: string | null;
    preview_url: string | null;
  };
  // Filtramos filas sin `nombre`: es la CLAVE que viaja como `voz_id` a Gemini
  // TTS; una vacía llegaría al picker y, si se elige, rompería la generación.
  return (data as Row[])
    .filter((v) => !!v.nombre)
    .map((v): GoogleVoice => ({
      id: String(v.id),
      nombre: v.nombre as string,
      estilo: v.estilo ?? null,
      sexo: v.sexo ?? null,
      descripcion: v.descripcion ?? null,
      previewUrl: v.preview_url ?? null,
    }));
}
